/**
 *
 */



class SelectView {

	constructor(nowView, poolObj) {

		if( nowView < 0 || nowView > 2 ) {   throw new Error('引数が不正です');   };

		this._nowView = nowView;

		this._SELECTBT_COLOR0 = { numb: 0,  back: [ 'rgb(25,90,245)', 'rgb(92,168,239)' ],  text: [  '#ffffff', '#eaeafa'  ]   };
		this._SELECTBT_COLOR1 = { numb: 1,  back: [ 'black', 'rgb(50,50,50)' ],  text: [  '#ffffff', '#eaeaea'  ]   };
		this._SELECTBT_COLOR2 = { numb: 2,  back: [ '#8888aa', 'rgb(230, 230, 245)' ],  text: [  '#111111', '#222222'  ]   };

		this._selectBtColorArray = [   this._SELECTBT_COLOR0, this._SELECTBT_COLOR1, this._SELECTBT_COLOR2   ];

		//
		this._state = StorageOperator.getStorageData('session', 'state');
		this._or34 = this._state.or34;

		//
		//let resultData = StorageOperator.getStorageData('session', 'nb_result');   
		//this._resultDataArr = resultData.array;

		this._resultDataArr = allDataObj.result;
		//

		let pool = poolObj;
		let poolArr = pool.array;


		this._dataHangar = new DataHangar( this._resultDataArr, this._or34);
		this._contPool = new ContentsPool( this._dataHangar, poolArr);


		//   ページ間state を反映
		let userCu = this._state['userCu'+this._or34] || null;
		let userSe = this._state['userSe'+this._or34] || null;

		this._userCOp = new UserCustomOperator(this._or34, this._dataHangar.nb);
		this._userCOp.setUserCustomStateObj( userCu );
		let userCuList = this._userCOp.getUserCustomList();

		this._contPool.setUserCustomList( userCuList );
		this._contPool.setDefaultSelectState( userSe );

		//
		this.setTopText();
		this.setSelectBtText();

		//  テーマ
		this._SELECTBT_COLOR = this._state.theme ?
								this._selectBtColorArray[this._state.theme] : this._selectBtColorArray[0];
		this._setColor();

		this._canvasViewObj = new CanvasView( this._SELECTBT_COLOR.numb );

		//  絞り係数
		this._coeffVal = COEFF_ARRAY;
		this._COEFF_SELECT_INDEX = COEFF_INDEX;
		this._coeffSelectIndex = COEFF_INDEX;
		this._setCoeffValue();


		this.allEventAdd();

	};


	get nowView() {   return this._nowView;   };
	set nowView(val) {
		if( val < 0 || val > 2 ) {   throw new Error('引数が不正です');   };
		this._nowView = val;
	};

	get state() {   return this._state;   };
	get or34() {   return this._or34;   };
	get dataHangar() {   return this._dataHangar;   };
	get contPool() {   return this._contPool;   };



	allEventAdd() {

		MyUtility.setElementEvent( 'selectBt0', 'click', () => this.selectBtClick(0), false );
		MyUtility.setElementEvent( 'selectBt1', 'click', () => this.selectBtClick(1), false );
		MyUtility.setElementEvent( 'selectBt2', 'click', () => this.selectBtClick(2), false );

		this.selectBtClick( this._nowView );

		MyUtility.setElementEvent( 'opre_Det', 'click', () => this.selectDete(), false );
		MyUtility.setElementEvent( 'opre_view', 'click', () => this.viewRangeChange(), false );

		MyUtility.setElementEvent( 'opre_Dete', 'click', () => this.selectDete(), false );

		//MyUtility.setElementEvent( 'etsReturn', 'click', () => this.pageReturn(), false );
		//MyUtility.setElementEvent( 'etsToResult', 'click', () => this.toResult(), false );
		MyUtility.setElementEvent( 'etsSelectOpPass', 'click', () => this.selectOpPass(), false );
		MyUtility.setElementEvent( 'etsSelectOpBack', 'click', () => this.selectOpBack(), false );
		MyUtility.setElementEvent( 'etsSelectOpClear', 'click', () => this.selectOpClear(), false );
		MyUtility.setElementEvent( 'etsTheme', 'click', () => this.themeChange(), false );


		if ("ontouchstart" in window && window.innerWidth < 600) {
			MyUtility.setElementEvent( 'selectBt', 'touchstart', () => this._popupDivHidden(), false );
			MyUtility.setElementEvent( 'center', 'touchstart', () => this._popupDivHidden(), false );
		};

		MyUtility.setElementEvent( 'coeffSelect', 'click', () => this.coeffSelectClick(), false );
	};

	//pageReturn() {   history.back();   };



	_popupDivHidden() {

		let state = document.formPopup.popupState.value;
		if(state==='show') {
			document.formPopup.popupState.value = 'close';
			document.getElementById('popupDiv').style.display = 'none';
		};
	};



	selectBtClick(val) {

		this._setSelectBtColor(val);
		this.nowView = val;
		this.setSelectBox();
	};


	//
	setTopText() {

		let len = this._contPool.contArray.length;
		let defLen = this._contPool.totalDefBooArray.length;
		let dupLen = this._contPool.totalDupBooArray.length;
		let def = this._contPool.totalPt;
		let dup = this._contPool.totalDupCount;

		MyUtility.setElementText( 'Count', 'C： '+len  );
		MyUtility.setElementText( 'topTextB', 'B： '+dup  );
		MyUtility.setElementText( 'topTextBA', '/'+dupLen  );
		MyUtility.setElementText( 'topTextS', 'S： '+def  );
		MyUtility.setElementText( 'topTextSA', '/'+defLen  );
	};


	setSelectBtText() {

		let pup3ObjList = this._contPool.getPickup3ObjList();

		for(var i=0, pObj=pup3ObjList, n=pObj.length; i<n; i++) {
			MyUtility.setElementText( 'select'+i+'BoxCt', pup3ObjList[i].totalDupCt+' / '+pup3ObjList[i].booDupArray.length  );
			MyUtility.setElementText( 'select'+i+'StrCt', pup3ObjList[i].totalDefCt+' / '+pup3ObjList[i].booDefArray.length  );
			MyUtility.setElementText( 'select'+i+'Pt',  pup3ObjList[i].predData.get('percent')+" %" );
		};
	};





	setSelectBox() {

		let pup3ObjList = this._contPool.getPickup3ObjList();
		let pup3Obj = pup3ObjList[ this.nowView ];

		this._canvasViewObj.setPup3ObjDataDeploy( pup3Obj );

		this._canvasViewObj.paintAll();
	};


	//  決定 ボタンClick 処理
	selectDete() {

		if( this._contPool.getPickup3ObjList()[this.nowView].totalDupCt === 0 ) {
			alert('絞込結果の個数が０になるため選択できません');
		}else {

			this._contPool.selectPickup3( this._nowView );

			this.setTopText();
			this.setSelectBtText();

			this.selectBtClick(0);
			this._setNowSelectStateToStorage();
		};
	};



	



	toResult() {

		let resultMap = ContentsPool.resultListToResultMap( this._contPool.getSelectResultList() );

		let arrKey = [];
		for(let key of resultMap.keys()) {   arrKey.push(key);   };
		let resultListObj = {  list: arrKey, page: 'pred'  };

		let boo = [true, true];
		try {
			boo = StorageOperator.setStorageData( 'session', 'resultList', resultListObj );
		}catch(exeption) {
			//alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};

		return boo[0];
	};




	//  パス ボタンClick 処理
	selectOpPass() {
		this._contPool.passPickup3Array();
		this.setSelectBtText();
		this.selectBtClick(0);
	};

	//  選択を 戻す ボタンClick 処理
	selectOpBack() {
		this._contPool.popContArray();

		this.setTopText();
		this.setSelectBtText();
		this.selectBtClick(0);
		this._setNowSelectStateToStorage();
	};

	//  クリア ボタンClick 処理
	selectOpClear() {
		this._contPool.clearContArray();

		this.setTopText();
		this.setSelectBtText();
		this.selectBtClick(0);
		this._setNowSelectStateToStorage();
	};

	//  テーマ変更
	themeChange() {

		for(let i=0, n=this._selectBtColorArray.length; i<n; i++) {
			if( this._SELECTBT_COLOR.numb === i ) {
				this._SELECTBT_COLOR = this._selectBtColorArray[(i+1)%n];
				break;
			};
		};

		this._setColor();

		this._canvasViewObj.themeChange();

		let boo = [true, true];
		try {
			boo = StorageOperator.storageSetProperty( 'theme', this._SELECTBT_COLOR.numb );
		}catch(exeption) {
			//alert('お使いのブラウザでは、本サイトは正常に動作しません');
		}

	};

	viewRangeChange() {

		this._canvasViewObj.canvasViewRangeChange();
	};




	_setColor() {

		MyUtility.setElementStyle( 'topDiv', 'background-color', this._SELECTBT_COLOR.back[0] );
		MyUtility.setElementStyle( 'topDiv', 'color', this._SELECTBT_COLOR.text[0] );
		MyUtility.setElementStyle( 'footerDiv', 'background-color', this._SELECTBT_COLOR.back[0] );
		MyUtility.setElementStyle( 'footerDiv', 'color', this._SELECTBT_COLOR.text[1] );

		MyUtility.setElementStyle( 'etsSelectOpPass', 'backgroundColor', this._SELECTBT_COLOR.back[0] );
		MyUtility.setElementStyle( 'etsSelectOpBack', 'backgroundColor', this._SELECTBT_COLOR.back[0] );
		MyUtility.setElementStyle( 'etsSelectOpClear', 'backgroundColor', this._SELECTBT_COLOR.back[0] );

		this._setSelectBtColor( this.nowView );

		this._setCenterLiColor();

	};

	_setSelectBtColor(val) {

		for(let i=0; i<3; i++) {
			if(val===i) {
				MyUtility.setElementStyle( 'selectBt'+i, 'background-color', this._SELECTBT_COLOR.back[0] );
			}else {
				MyUtility.setElementStyle( 'selectBt'+i, 'background-color', this._SELECTBT_COLOR.back[1] );
			};
			MyUtility.setElementStyle( 'selectBt'+i, 'color', this._SELECTBT_COLOR.text[0] );
			MyUtility.setElementStyle( 'selectBt'+i, 'border-color', this._SELECTBT_COLOR.text[1] );
		};
	};

	_setCenterLiColor() {
		for(let i=0; i<3; i++) {
			MyUtility.setElementStyle( 'centerLi_'+i, 'backgroundColor', this._SELECTBT_COLOR.back[1] );
			MyUtility.setElementStyle( 'centerLi_'+i, 'border-color', this._SELECTBT_COLOR.text[1] );
		};
	};



	//  sessionStorageの、state 要素に、現在の選択結果を更新
	_setNowSelectStateToStorage() {

		let boo = [true, true];
		try {
			boo = StorageOperator.storageSetProperty(  'userSe'+this._or34, this._contPool.userSelectIndexArray );
		}catch(exeption) {
			//alert('お使いのブラウザでは、本サイトは正常に動作しません');
		};
		return boo;
	};




	//  絞係数
	_setCoeffValue() {

		let frag = document.createDocumentFragment();
		let select = document.getElementById( 'coeffSelect' );

		for(let i=0, n=this._coeffVal.length; i<n; i++) {
			let option = document.createElement( 'option' );
			option.value = this._coeffVal[i];
			option.appendChild( document.createTextNode( this._coeffVal[i] ) );
			frag.appendChild(option);
		};
		select.appendChild( frag );

		let coeffVal = StorageOperator.getStorageData('session', 'state').coeffValue;

		if(coeffVal) {
			select.selectedIndex = this._coeffVal.findIndex( (val) => val===coeffVal );
		}else {
			let stateObj = StorageOperator.getStorageData('session', 'state');

			select.selectedIndex = this._COEFF_SELECT_INDEX;
			stateObj.coeffValue = this._coeffVal[ this._COEFF_SELECT_INDEX ];
			let boo = [true, true];
			try {
				boo = StorageOperator.setStorageData( 'session', 'state', stateObj );
			}catch(exeption) {
				//alert('お使いのブラウザでは、本サイトは正常に動作しません');
			};
		}

	};

	coeffSelectClick() {

		let index = document.getElementById( 'coeffSelect' ).selectedIndex;
		let stateObj = StorageOperator.getStorageData('session', 'state');
		let coeff = this._coeffVal[ index ];

		if( ! stateObj.coeffValue || (stateObj.coeffValue && stateObj.coeffValue !== coeff )) {

			stateObj.coeffValue = coeff;
			let boo = [true, true];
			try {
				boo = StorageOperator.setStorageData( 'session', 'state', stateObj );

			}catch(exeption) {
				//alert('お使いのブラウザでは、本サイトは正常に動作しません===');
			};

			if(boo) {
				this._contPool.coeffValChange( coeff );
	
				this.selectOpPass();
			};

		};
		
	};

	coeffSelectReset() {

		document.getElementById( 'coeffSelect' ).selectedIndex = this._COEFF_SELECT_INDEX;

		let stateObj = StorageOperator.getStorageData('session', 'state');
		if(stateObj.coeffValue && stateObj.coeffValue!==this._coeffVal[this._COEFF_SELECT_INDEX]) {
			stateObj.coeffValue = this._coeffVal[ this._COEFF_SELECT_INDEX ];
			let boo = [true, true];
			try {
				boo = StorageOperator.setStorageData( 'session', 'state', stateObj );
			}catch(exeption) {
				//alert('お使いのブラウザでは、本サイトは正常に動作しない可能性があります。');
			};
		};
	};



};






